/* Desktop-only sparkle/glitter cursor trail. Disabled on touch devices and
   when the user prefers reduced motion. Pure JS, no dependencies. */
(function () {
  var fine = window.matchMedia && window.matchMedia("(pointer:fine)").matches;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!fine || reduce) return;

  var MASK =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath d='M50 0c4 28 18 42 50 50-32 8-46 22-50 50-4-28-18-42-50-50 32-8 46-22 50-50z'/%3E%3C/svg%3E\") center / contain no-repeat";
  var COLORS = ["#ED2F8E", "#FF53A8", "#18BFEF", "#8E5BD6", "#ffffff"];

  var layer = document.createElement("div");
  layer.setAttribute("aria-hidden", "true");
  layer.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden";
  function mount() {
    document.body.appendChild(layer);
  }
  if (document.body) mount();
  else document.addEventListener("DOMContentLoaded", mount);

  var lastT = 0,
    lastX = 0,
    lastY = 0;

  function spawn(x, y, scale) {
    var s = document.createElement("span");
    var size = (5 + Math.random() * 11) * (scale || 1);
    var color = COLORS[(Math.random() * COLORS.length) | 0];
    var ox = (Math.random() - 0.5) * 16,
      oy = (Math.random() - 0.5) * 16;
    var driftX = (Math.random() - 0.5) * 46;
    var driftY = 14 + Math.random() * 48; // gravity — glitter falls
    var rot = Math.random() * 220 - 110;
    s.style.cssText =
      "position:absolute;left:0;top:0;width:" +
      size +
      "px;height:" +
      size +
      "px;background:" +
      color +
      ";-webkit-mask:" +
      MASK +
      ";mask:" +
      MASK +
      ";will-change:transform,opacity;filter:drop-shadow(0 0 2px " +
      color +
      "88)";
    layer.appendChild(s);
    var dur = 434 + Math.random() * 294;
    var anim = s.animate(
      [
        { transform: "translate(" + (x + ox) + "px," + (y + oy) + "px) scale(" + 0.6 + ") rotate(0deg)", opacity: 0 },
        {
          transform: "translate(" + (x + ox) + "px," + (y + oy) + "px) scale(1) rotate(" + rot * 0.3 + "deg)",
          opacity: 1,
          offset: 0.18,
        },
        {
          transform:
            "translate(" + (x + ox + driftX) + "px," + (y + oy + driftY) + "px) scale(0.15) rotate(" + rot + "deg)",
          opacity: 0,
        },
      ],
      { duration: dur, easing: "cubic-bezier(.33,0,.5,1)" },
    );
    anim.onfinish = function () {
      s.remove();
    };
  }

  window.addEventListener(
    "mousemove",
    function (e) {
      var now = performance.now();
      var dx = e.clientX - lastX,
        dy = e.clientY - lastY;
      var dist = Math.hypot(dx, dy);
      if (now - lastT < 26 && dist < 9) return; // throttle
      lastT = now;
      lastX = e.clientX;
      lastY = e.clientY;
      spawn(e.clientX, e.clientY, 1);
      if (dist > 46) spawn(e.clientX - dx * 0.45, e.clientY - dy * 0.45, 0.85); // fill gaps on fast moves
    },
    { passive: true },
  );

  // A little burst on click — extra delight.
  window.addEventListener(
    "mousedown",
    function (e) {
      for (var i = 0; i < 7; i++) spawn(e.clientX, e.clientY, 0.7 + Math.random() * 0.6);
    },
    { passive: true },
  );
})();
